<template>
  <div>
    <h5>Подтверждение кода из смс {{ order.card.phone }}</h5>
    <fg-input :type="`number`" :label="`Введите код из смс, которое пришло клиенту`" v-model="code"></fg-input>
    <br />
    <br />
    <div class="install-control">
      <button @click="next" class="btn btn-success">{{ 'next_step' | setText('Далее') }}</button>
    </div>
  </div>
</template>
<script>
import { logger } from '../../../plugins/functions';

export default {
  props: {
    order: {
      default: function () {
        return {};
      },
    },
    partner: {
      default: function () {
        return {};
      },
    },
    index: {
      default: 0
    },
    hash: {
      default: null
    },
    buyer: {
      default: null
    },
  },
  name: "filter",
  async created() {

  },
  methods: {

    next() {
      this.save();
    },
    prev() {
      this.$emit('next', this.index - 1);
    },
    save() {
      this.$loading(true);

      logger(this.$http, {
        name: 'Подтверждение пластиковой карты пользователя в #PAYMART',
        description: 'Начало запроса #PAYMART',
        model_type: 'order',
        model_id: this.order.id
      });

      this.$http
        .post(`${this.partner['endpoint_url']}buyer/check-sms-code-uz`,
          {
            phone: this.order.card.phone,
            card_valid_date: this.order.card.exp,
            card_number: this.order.card.card_number,
            hashedCode: this.hash,
            code: this.code,
            buyer_id: this.buyer,
          },
          {
            headers: {
              'Authorization': `Bearer ${this.partner['api_secret_key']}`,
              'Content-Type': 'application/json'
            }
          })
        .then((response) => {
          if (response.data) {
            switch (response.data.status) {
              case 'success':
                this.message = 'Код подтвержден';
                setTimeout(() => {
                  this.$emit('next', 6);
                }, 10);
                break;
              case 'error':
                this.message = 'Неверный код из смс';
                break;
              default:
                this.message = 'Неизвестная ошибка';
                break;
            }

            logger(this.$http, {
              name: 'Подтверждение пластиковой карты пользователя в #PAYMART',
              description: this.message,
              model_type: 'order',
              model_id: this.order.id
            });
          }
          this.$notify({
            title: "PAYMART",
            message: this.message,
            icon: "ti-save",
            horizontalAlign: "right",
            verticalAlign: "top",
          });
        })
        .catch((error) => {
          logger(this.$http, {
            name: 'Подтверждение пластиковой карты пользователя в #PAYMART',
            description: 'Ошибка партнера #PAYMART',
            model_type: 'order',
            model_id: this.order.id
          });
          alert('Ошибка партнера');

        })
        .finally(() => {
          this.$loading(false);
        });
    },
  },
  data() {
    return {
      code: null,
      message: ''
    };
  },
};
</script>
<style lang="scss">

</style>
